import React from 'react'

import { createSvgIcon } from './utils/create-svg-icon'

export const MoneyCoinsIcon = createSvgIcon(
  <>
    <title>money coins</title>
    <g
      className="nc-icon-wrapper"
      fill="#222222"
      stroke="#222222"
      strokeLinecap="square"
      strokeLinejoin="miter"
      strokeWidth="1"
      transform="translate(0.5 0.5)"
    >
      <polyline
        fill="none"
        points="15,23 1,23 1,1 31,1 31,15 "
        stroke="#222222"
        strokeMiterlimit="10"
      />{' '}
      <circle
        cx="16"
        cy="12"
        fill="none"
        r="3"
        stroke="#222222"
        strokeMiterlimit="10"
      />{' '}
      <path
        d="M27,13V9 c-2.259,0-4-1.741-4-4H9c0,2.259-1.741,4-4,4v6c2.259,0,4,1.741,4,4h6"
        fill="none"
        stroke="#222222"
        strokeMiterlimit="10"
      />{' '}
      <path
        d="M19,20v4c0,1.657,2.686,3,6,3 s6-1.343,6-3v-4"
        data-cap="butt"
        data-color="color-2"
        fill="none"
        strokeLinecap="butt"
        strokeMiterlimit="10"
      />{' '}
      <path
        d="M19,24v4c0,1.657,2.686,3,6,3 s6-1.343,6-3v-4"
        data-cap="butt"
        data-color="color-2"
        fill="none"
        strokeLinecap="butt"
        strokeMiterlimit="10"
      />{' '}
      <ellipse
        cx="25"
        cy="20"
        data-color="color-2"
        fill="none"
        rx="6"
        ry="3"
        strokeMiterlimit="10"
      />
    </g>
  </>
)
